var map = {
	"./fosdem2025.png": 739,
	"./fosdem_ci_purple.png": 654,
	"./fosdem_ci_white.png": 777,
	"./fosdem_plan_solbosch.jpg": 656,
	"./sumup.gif": 32,
	"./talkie.jpg": 856,
	"./team_fosdem/logo.jpg": 254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 382;